import {AlgorithmicDmvJobDetail, AlgorithmicDmvJobInfo} from "../generated-sources/api";
import {ApiDataModel} from "../../shared/model/api-data-model";

export interface AlgorithmicDmvState {
    jobsByFund: { [fundId: number]: ApiDataModel<AlgorithmicDmvJobInfo[]> };
    activeDetail: ApiDataModel<AlgorithmicDmvJobDetail | undefined>;
    pendingActionResultIds: number[];
    /** True while a bulk "Accept all" run is in flight (disables the header action). */
    bulkAccepting: boolean;
    error?: string;
}

export const initialAlgorithmicDmvState: AlgorithmicDmvState = {
    jobsByFund: {},
    activeDetail: {data: undefined, status: "INIT", errorMessage: ""},
    pendingActionResultIds: [],
    bulkAccepting: false
};
